import { adminApi } from "../api/admin";
import { ownerApi } from "../api/owner";
import { viewerApi } from "../api/viewer";
import type { CurrentUser, Report } from "../types";

export type Mode = "admin" | "owner" | "viewer";

export const ADMIN_ROLES = ["platform_admin", "report_admin"];

export function modeFor(user: CurrentUser | null): Mode {
  if (!user) return "viewer";
  if (user.roles.some((r) => ADMIN_ROLES.includes(r))) return "admin";
  if (user.roles.includes("report_owner")) return "owner";
  return "viewer";
}

/** URL prefix each role's screens live under (kept for backward compatibility
 * with the login redirect and existing bookmarks). */
export function basePath(mode: Mode): string {
  return mode === "admin" ? "/admin" : mode === "owner" ? "/owner" : "/viewer";
}

export function listReportsFor(mode: Mode): Promise<Report[]> {
  if (mode === "admin") return adminApi.listReports();
  if (mode === "owner") return ownerApi.listReports();
  return viewerApi.listReports();
}

export function reportUrl(mode: Mode, id: string): string {
  return mode === "viewer" ? `/viewer/reports/${id}` : `${basePath(mode)}/reports/${id}`;
}

export function designerUrl(mode: Mode, id: string): string {
  return `${basePath(mode)}/reports/${id}/edit`;
}
